// eslint-disable-next-line no-restricted-imports

import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { breakpoints, spaces } from '@99designs/emu/settings';

interface Props {
    size?: Sizes;
    children: ReactNode;
}

interface StyledContentSettingProps {
    maxWidth: string;
}

const StyledContentSetting = styled.div<StyledContentSettingProps>`
    max-width: ${(props) => props.maxWidth};
    position: relative;
    margin: auto;
    padding-left: ${spaces['2bu']};
    padding-right: ${spaces['2bu']};

    @media screen and (max-width: ${breakpoints.small[1]}px) {
        padding-left: ${spaces['1bu']};
        padding-right: ${spaces['1bu']};
    }
`;

export enum Sizes {
    Default = '1000px',
    Small = '650px',
    Full = 'initial',
}

export default function ContentSetting({ size, children }: Props) {
    return (
        <StyledContentSetting maxWidth={size ? size : Sizes.Default}>
            {children}
        </StyledContentSetting>
    );
}
